import {
  WEBSITE_SOURCE_DATA_KEY_MAPPING,
  getWebsiteSourceDataByKey,
  getComponentByType,
  COMPONENT_TYPE_MAPPING,
} from '@bingads-webui-campaign-react/smart-component-util';

const componentKey = WEBSITE_SOURCE_DATA_KEY_MAPPING.PrivacyPolicy;

export const proxyReadPrivacyPolicyComponentConfig = (siteConfig) => {
  const policyContent = getWebsiteSourceDataByKey(siteConfig, componentKey);
  const { isPrivacyStatementReviewed } = getComponentByType(
    siteConfig,
    COMPONENT_TYPE_MAPPING.Footer
  );

  return {
    policyContent,
    isPrivacyStatementReviewed,
  };
};
